module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition', {
    attrs: {
      "name": "layout"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "layout-opacity",
    class: [_vm.position == 'top-header' ? 'layout-header' : ''],
    on: {
      "click": _vm.handleClick
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.animate[_vm.position]
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "drawer",
    class: ['drawer-' + _vm.position]
  }, [_c('div', {
    staticClass: "drawer-box"
  }, [_vm._t("default")], 2)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2953f215!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/drawer/drawer.vue
// module id = 33
// module chunks = 1 4 9